export const getTimesheetViewer = (state) => {
  return state.timesheetViewer;
};

export const getCurrentSubmissionId = (state) => {
  const { currentSubmissionId } = getTimesheetViewer(state);
  return currentSubmissionId;
};

export const getUserId = (state) => {
  const { userId } = getTimesheetViewer(state);
  return userId;
};

export const getWeekOfDate = (state) => {
  const { weekOfDate } = getTimesheetViewer(state);
  return weekOfDate;
};
